module.exports = __webpack_public_path__ + "img/shanxi.e98a2e4c.png";